
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'customer-portal-app',
  currentProjectVersion: 'static-1.3021',
  depVersions: {
  "customer-portal-app": "static-1.3021",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.491",
  "data-fetching-client": "static-1.9908",
  "emoji-mart": "static-3.4",
  "enviro": "static-4.455",
  "growth-payments-core": "static-1.26082",
  "head-dlb": "static-1.5007",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5849",
  "hs-test-utils": "static-1.8278",
  "hub-http": "static-1.6465",
  "hub-http-shared-msw-handlers": "static-1.10534",
  "hubspot-dlb": "static-2.1882",
  "hubspot-prosemirror": "static-1.18880",
  "hubspot-url-utils": "static-1.4297",
  "HubStyleTokens": "static-2.11735",
  "I18n": "static-7.1663",
  "immutable": "static-2.83",
  "jasmine-runner": "static-1.6700",
  "payment-link-components": "static-1.24087",
  "portals-platform-bend-plugin": "static-1.17",
  "prosemirror": "static-1.13",
  "quartz": "static-1.7373",
  "quartz-core": "static-1.6592",
  "quartz-i18n": "static-1.1048",
  "react": "static-7.191",
  "react-colorpicker": "static-2.10460",
  "react-dlb": "static-1.85",
  "react-utils": "static-2.5520",
  "reselect": "static-3.9",
  "rich-text-lib": "static-1.20241",
  "transmute": "static-2.85",
  "ui-addon-upgrades": "static-9.18324",
  "ui-components-test-utils": "static-1.5872",
  "UIComponents": "static-3.8681",
  "foundations-assets": "static-1.5131",
  "foundations-components": "static-1.8394",
  "foundations-theming": "static-1.4710",
  "foundations-theming-specialty": "static-1.2426",
  "framer-motion": "static-1.76",
  "metrics-js": "static-1.9867",
  "PortalIdParser": "static-2.404",
  "portals-platform-lib": "static-1.1361",
  "quartz-config": "static-1.1151",
  "quartz-routing": "static-1.803",
  "quick-fetch": "static-1.4097",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1-unify-reporter-duration-calculations.8",
  "rpc-client-utils": "static-1.4915",
  "sanitize-text": "static-1-fix-mxss-decode-tags-foreign-content.3",
  "styled-components": "static-2.95",
  "tanstack-table": "static-1.59",
  "ui-addon-draggable": "static-3.5007",
  "ui-addon-react-router-dom": "static-1.9789",
  "usage-tracker": "static-1.7608",
  "usage-tracker-anonymous": "static-1.6025",
  "usage-tracker-core": "static-1.7458",
  "video-components-external": "static-1.12071",
  "apollo-stack-hubspot": "static-3.84",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "react-redux": "static-7.75",
  "redux": "static-4.76",
  "bend-plugin-trellis-migration": "static-1.3582",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3650",
  "quartz-webpack": "static-1.3597",
  "bend-plugin-quartz-routing": "static-1.451",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.86",
  "customer-data-objects": "static-1.7938",
  "frontend-preferences-client": "static-1.8180",
  "laboratory-lib": "static-3.7404",
  "onboarding-scopes": "static-1.6707",
  "seat-types-lib": "static-1.630",
  "ui-addon-opt": "static-4.8617",
  "HeadJS": "static-2.790",
  "hs-test-utils-bend-plugin": "static-1.3389",
  "msw": "static-1.39",
  "testing-library": "static-1.156",
  "hs-locale-management": "static-1.259",
  "ts-schema": "static-1.4259",
  "webpack-env": "static-1.54",
  "content-assistance-lib": "static-1.8138",
  "content-media-capture": "static-1.5320",
  "cssUtils": "static-1.872",
  "customer-data-ui-utilities": "static-1.10079",
  "file-manager-components": "static-1.24368",
  "HubStyle": "static-2.12042",
  "knowledge-content-types": "static-1.8621",
  "PatternValidationJS": "static-1.3149",
  "react-input-autosize": "static-2.17",
  "StyleGuideUI": "static-3.495",
  "ui-addon-emoji-picker": "static-1.10136",
  "ui-addon-i18n": "static-1.11396",
  "ui-business-units-lib": "static-1.9335",
  "ui-shepherd-react": "static-3.10515",
  "video-data-lib": "static-1.35729",
  "i18n-data": "static-1.227",
  "moment-timezone": "static-5.87",
  "jasmine": "static-4.4569",
  "commerce-tours-lib": "static-1.6541",
  "customer-data-properties": "static-1.52447",
  "getting-started-shared-tasks": "static-1.19123",
  "growth-onboarding-reliability": "static-1.5333",
  "onboarding-tours": "static-1.17045",
  "reference-resolvers-lite": "static-1.8351",
  "sales-checkout-service-client": "static-1.3779",
  "ui-addon-iframeable": "static-1.9327",
  "user-context": "static-1.5366",
  "bender-build-tools": "static-1.3382",
  "dispatcher": "static-1.141",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.870",
  "hubspotter-http": "static-1.4828",
  "icons": "static-2.674",
  "mobile-manifest-mixins": "static-1.567",
  "module-federation": "static-1.30",
  "quartz-auth": "static-1.1048",
  "quartz-head": "static-1.1038",
  "quartz-test": "static-1.1048",
  "quartz-tracking": "static-1.752",
  "trellis-components": "static-1.2501",
  "ui-fonts": "static-1.997",
  "usage-tracker-container": "static-1.7598",
  "csstype": "static-1.50",
  "hs-story-utils": "static-1.9678",
  "data-token-picker": "static-1.16819",
  "FileManagerLib": "static-1.40008",
  "property-translator": "static-1.5648",
  "atom": "static-1.5337",
  "merchandise-lib": "static-1.273",
  "purchase-motions-components": "static-1.6289",
  "salesImages": "static-1.530",
  "SharedI18nStrings": "static-1.182",
  "foundations-components-test-utils": "static-1.5877",
  "react-create-root-preference": "static-1.63",
  "react-select-plus": "static-1.109",
  "react-virtualized": "static-2.104",
  "ui-images": "static-2.1230",
  "bend-plugin-foundations-components": "static-1.4663",
  "floating-ui": "static-1.62",
  "react-aria": "static-1.70",
  "trellis-assets": "static-1.2482",
  "bend-plugin-foundations-theming": "static-1.3193",
  "foundations-theming-base": "static-1.3695",
  "stylex": "static-1.38",
  "interframe": "static-3.5008",
  "js-cookie": "static-1.18",
  "usage-tracker-multi": "static-1.6022",
  "web-vitals": "static-1.11",
  "bend-plugin-chirp-manifest": "static-1.325",
  "chirp-fetch": "static-1.2143",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4728",
  "react-flip-move": "static-1.75",
  "apollo-link-hub-http": "static-2.4909",
  "content-media-composition-data-lib": "static-1.13124",
  "content-media-compositions": "static-2.17131",
  "idb-keyval": "static-1.48",
  "immer": "static-1.94",
  "immerable": "static-1.4403",
  "magpie-lib": "static-1.5722",
  "magpie-types": "static-1.5182",
  "media-bridge-lib": "static-1.19343",
  "inbound-db-properties-service-client": "static-1.4023",
  "superstore": "static-1.5008",
  "feedback-loader": "static-1.29740",
  "ai-components-ui-library": "static-1.9601",
  "ui-addon-video-player": "static-1.8955",
  "ui-coaching-tips": "static-1.29223",
  "ContentUtils": "static-1.69063",
  "fix-webm-duration": "static-1.27",
  "notification-sounds": "static-1.4676",
  "sassPrefix": "static-1.161",
  "react-dnd-compat": "static-1.4867",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "breeze-engine-lib": "static-1.1580",
  "copilot-toolkit": "static-1.11755",
  "avatar-components": "static-1.2749",
  "navigation-messaging": "static-1.8048",
  "redux-thunk": "static-2.77",
  "reference-resolvers": "static-1.8433",
  "commerce-products-lib": "static-1.10416",
  "crm-message-bus": "static-1.43649",
  "growth-data-modal": "static-1.5824",
  "hubspot-apollo-client": "static-1.5131",
  "onboarding-tours-client": "static-1.5259",
  "batch-promise": "static-1.1794",
  "calling-global-api": "static-1.65387",
  "calling-internal-common": "static-1.31568",
  "calling-lifecycle-internal": "static-1.66769",
  "calling-lifecycle-messages": "static-1.59063",
  "conditional-properties-service-client": "static-1.3980",
  "crm-index-visualization-core": "static-1.4482",
  "crm-links": "static-1.6576",
  "crm-pipelines-api-client-types": "static-1.4314",
  "customer-data-objects-ui-components": "static-1.13281",
  "customer-data-properties-shared-msw-handlers": "static-1.9861",
  "customer-data-property-utils": "static-1.8350",
  "external-options-client-types": "static-1.4305",
  "formula-editor": "static-1.14683",
  "framework-data-schema-resolvers": "static-1.7144",
  "google-libphonenumber": "static-1.42",
  "hs-resources": "static-1.443",
  "inbound-db-meta-service-client": "static-1.3718",
  "inbounddb-objects-service-types": "static-1.4390",
  "meetings-icalendar-utils-lib": "static-1.888",
  "multi-currency-client-types": "static-1.3874",
  "object-builder-ui-client": "static-1.49546",
  "pipeline-validation-client-types": "static-1.4148",
  "property-value-citations": "static-1.3061",
  "pulse": "static-1.878",
  "smart-data-capture-core": "static-1.35",
  "smart-property-lib": "static-1.8176",
  "tiered-pricing": "static-1.1873",
  "trial-components-library": "static-1.14029",
  "topics-actions-lib": "static-1.415",
  "ui-addon-form-validation": "static-1.11238",
  "zustand": "static-1.79",
  "growth-onboarding-confetti": "static-1.3313",
  "growth-onboarding-next-action-utils": "static-1.2603",
  "navigation-components": "static-1.18721",
  "onboarding-tours-utils": "static-1.1111",
  "ui-shepherd-tracker": "static-1.7896",
  "ui-universal-auth": "static-1.9300",
  "getting-started-shared-tasks-store": "static-1.18241",
  "hubspotter-http-shared-msw-handlers": "static-1.10532",
  "usage-tracker-session-replay": "static-1.5294",
  "base-ui": "static-1.19",
  "react-day-picker": "static-1.7",
  "trellis-theming": "static-1.1214",
  "tanstack-virtual": "static-1.36",
  "audio-components": "static-1.6279",
  "FileManagerCore": "static-1.39867",
  "FileManagerImages": "static-1.37519",
  "video-components": "static-1.14073",
  "foundations-components-legacy": "static-1.1419",
  "purchase-motions-api": "static-1.6292",
  "signup-constants": "static-1.19512",
  "signup-ui-url-generator": "static-2.8310",
  "usage-tracker-public": "static-1.7419",
  "reactive-lib": "static-1.973",
  "simple-logging-lib": "static-1.3302",
  "chatspot-core": "static-1.22661",
  "growth-onboarding-feedback-components": "static-1.6835",
  "cms-field-types": "static-1.5067",
  "content-icons-ui": "static-1.2316",
  "integrations-lib": "static-1.16936",
  "underscore": "static-1.8",
  "breeze-engine-chat-components": "static-1.558",
  "breeze-engine-core": "static-1.858",
  "ably": "static-2.2",
  "highlight.js": "static-1.83",
  "markdown-it": "static-1.6",
  "commerce-permissions": "static-1.1028",
  "customer-data-tracking": "static-1.7133",
  "products-iframe-lib": "static-1.8505",
  "products-ui-components-shared-msw-handlers": "static-1.10916",
  "restore-request-side-panel-lib": "static-1.1563",
  "onboarding-data-sync-lib": "static-1.2420",
  "hubspot-apollo-cache": "static-1.590",
  "calling-error-reporting": "static-1.31575",
  "shared-worker-versioning": "static-1.11293",
  "calling-usage-tracker": "static-1.6791",
  "voice-sms-access-library": "static-1.1921",
  "conversations-skeleton-state": "static-1.7500",
  "crm-index-associations-lib": "static-1.6696",
  "framework-data-schema-quick-fetch": "static-1.7049",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10617",
  "redux-toolkit": "static-1.75",
  "sales-views-client-types": "static-1.4509",
  "location-customization-utils-lib": "static-1.9998",
  "bark-lib": "static-1.16757",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.99",
  "crm-properties-common-lib": "static-1.6141",
  "react-codemirror": "static-1.10891",
  "fdsr-migration-layer": "static-1.263",
  "framework-builder-read-service-client": "static-1.4186",
  "persist-promise": "static-1.3951",
  "event-emitter": "static-1.1206",
  "bend-plugin-pulse": "static-1.381",
  "fast-json-patch": "static-1.67",
  "data-agent-kit": "static-1.580",
  "fsm": "static-1.3991",
  "policy-lib": "static-1.7047",
  "react-tinymce": "static-1.55885",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10680",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.55011",
  "tinymce-plugins": "static-1.58125",
  "tinymce-themes": "static-1.56981",
  "embedded-academy-lib": "static-1.15381",
  "hubs-service-types": "static-1.1510",
  "growth-onboarding-next-action-components": "static-1.2631",
  "user-context-client": "static-1.4760",
  "nest": "static-1.487",
  "unified-auth-core-lib": "static-1.1096",
  "amplitude-session-replay-browser": "static-1.60",
  "breeze-artifacts-sdk": "static-1.201",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.58",
  "urlinator": "static-1.4784",
  "video-embed": "static-1.36563",
  "social-insights-client-types": "static-1.22685",
  "flux-actions": "static-1.360",
  "integrations-error-boundary-lib": "static-1.14351",
  "integrations-tracking-lib": "static-1.5859",
  "native-integrations-shared-strings": "static-1.8029",
  "redux-observable": "static-1.72",
  "ReduxMessenger": "static-2.10618",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.814",
  "InboxConnectUtils": "static-4.15466",
  "meetings-connect-utils-lib": "static-1.7861",
  "calling-orchestration-schema": "static-1.36698",
  "crm-record-cards-service-types": "static-1.3759",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16275",
  "browser-eslint": "static-2.57",
  "highcharts": "static-8.108",
  "trellis-story-utils": "static-1.4763",
  "storybook-react": "static-1.37",
  "hub-http-contrib": "static-1.3291",
  "tinymce-data": "static-1.41096",
  "ui-addon-sales-email": "static-1.5466",
  "layout-dnd-components": "static-1.12898",
  "layout-dnd-utils": "static-1.11873",
  "ui-brand-identity-lib": "static-1.16233",
  "NamespacedHubStyle": "static-2.9227",
  "academy-common-lib": "static-1.14841",
  "outpost": "static-1.4412",
  "universal-page-editor-lib": "static-1.3260",
  "adobe-sign-auth-lib": "static-1.362",
  "ads-unified-auth-lib": "static-1.1076",
  "google-sheets-integration-lib": "static-1.939",
  "microsoft-drive-auth-lib": "static-1.31",
  "surveymonkey-integration-lib": "static-1.383",
  "slack-ui-library": "static-1.10650",
  "ContentData": "static-1.69138",
  "layout-data-lib": "static-1.10198",
  "academy-service-client": "static-1.3941",
  "croppie": "static-2.10",
  "final-form": "static-1.75",
  "SafeStorage": "static-1.4657",
  "trellis-ecosystem": "static-1.7565",
  "wootric-nps": "static-1.7165",
  "advanced-menus-core": "static-1.15516",
  "advanced-menus-lib": "static-1.12396",
  "ExportDialog": "static-6.10631",
  "ui-memberships-settings-lib": "static-1.34745",
  "marketplace-ui-apps-core": "static-1.19145",
  "marketplace-ui-common": "static-1.20613",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15515",
  "simple-menus-lib": "static-1.17032",
  "developer-experience-shared-components": "static-1.10753",
  "immutable-less": "static-1.4903",
  "marketplace-ui-client-types": "static-1.18020",
  "ui-addon-integrations-directory-panel": "static-2.8278",
  "ui-extensibility-client-types": "static-1.4173",
  "ai-settings-ui-library": "static-1.8263",
  "nav-meta": "static-1.30358",
  "react-window": "static-1.13",
  "ui-product-approvals-common": "static-1.889",
  "apps-service-types": "static-1.3995",
  "oauth-service-types": "static-1.4507",
  "simple-data-table": "static-1.3443"
},
  depPathPrefixes: {
  "customer-portal-app": "/customer-portal-app/static-1.3021",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.491",
  "data-fetching-client": "/data-fetching-client/static-1.9908",
  "emoji-mart": "/emoji-mart/static-3.4",
  "enviro": "/enviro/static-4.455",
  "growth-payments-core": "/growth-payments-core/static-1.26082",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5849",
  "hs-test-utils": "/hs-test-utils/static-1.8278",
  "hub-http": "/hub-http/static-1.6465",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10534",
  "hubspot-dlb": "/hubspot-dlb/static-2.1882",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18880",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4297",
  "HubStyleTokens": "/HubStyleTokens/static-2.11735",
  "I18n": "/I18n/static-7.1663",
  "immutable": "/immutable/static-2.83",
  "jasmine-runner": "/jasmine-runner/static-1.6700",
  "payment-link-components": "/payment-link-components/static-1.24087",
  "portals-platform-bend-plugin": "/portals-platform-bend-plugin/static-1.17",
  "prosemirror": "/prosemirror/static-1.13",
  "quartz": "/quartz/static-1.7373",
  "quartz-core": "/quartz-core/static-1.6592",
  "quartz-i18n": "/quartz-i18n/static-1.1048",
  "react": "/react/static-7.191",
  "react-colorpicker": "/react-colorpicker/static-2.10460",
  "react-dlb": "/react-dlb/static-1.85",
  "react-utils": "/react-utils/static-2.5520",
  "reselect": "/reselect/static-3.9",
  "rich-text-lib": "/rich-text-lib/static-1.20241",
  "transmute": "/transmute/static-2.85",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18324",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5872",
  "UIComponents": "/UIComponents/static-3.8681",
  "foundations-assets": "/foundations-assets/static-1.5131",
  "foundations-components": "/foundations-components/static-1.8394",
  "foundations-theming": "/foundations-theming/static-1.4710",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2426",
  "framer-motion": "/framer-motion/static-1.76",
  "metrics-js": "/metrics-js/static-1.9867",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "portals-platform-lib": "/portals-platform-lib/static-1.1361",
  "quartz-config": "/quartz-config/static-1.1151",
  "quartz-routing": "/quartz-routing/static-1.803",
  "quick-fetch": "/quick-fetch/static-1.4097",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1-unify-reporter-duration-calculations.8",
  "rpc-client-utils": "/rpc-client-utils/static-1.4915",
  "sanitize-text": "/sanitize-text/static-1-fix-mxss-decode-tags-foreign-content.3",
  "styled-components": "/styled-components/static-2.95",
  "tanstack-table": "/tanstack-table/static-1.59",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5007",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9789",
  "usage-tracker": "/usage-tracker/static-1.7608",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6025",
  "usage-tracker-core": "/usage-tracker-core/static-1.7458",
  "video-components-external": "/video-components-external/static-1.12071",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "react-redux": "/react-redux/static-7.75",
  "redux": "/redux/static-4.76",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3582",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3650",
  "quartz-webpack": "/quartz-webpack/static-1.3597",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.451",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.86",
  "customer-data-objects": "/customer-data-objects/static-1.7938",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8180",
  "laboratory-lib": "/laboratory-lib/static-3.7404",
  "onboarding-scopes": "/onboarding-scopes/static-1.6707",
  "seat-types-lib": "/seat-types-lib/static-1.630",
  "ui-addon-opt": "/ui-addon-opt/static-4.8617",
  "HeadJS": "/HeadJS/static-2.790",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3389",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.156",
  "hs-locale-management": "/hs-locale-management/static-1.259",
  "ts-schema": "/ts-schema/static-1.4259",
  "webpack-env": "/webpack-env/static-1.54",
  "content-assistance-lib": "/content-assistance-lib/static-1.8138",
  "content-media-capture": "/content-media-capture/static-1.5320",
  "cssUtils": "/cssUtils/static-1.872",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10079",
  "file-manager-components": "/file-manager-components/static-1.24368",
  "HubStyle": "/HubStyle/static-2.12042",
  "knowledge-content-types": "/knowledge-content-types/static-1.8621",
  "PatternValidationJS": "/PatternValidationJS/static-1.3149",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "StyleGuideUI": "/StyleGuideUI/static-3.495",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10136",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11396",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9335",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10515",
  "video-data-lib": "/video-data-lib/static-1.35729",
  "i18n-data": "/i18n-data/static-1.227",
  "moment-timezone": "/moment-timezone/static-5.87",
  "jasmine": "/jasmine/static-4.4569",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6541",
  "customer-data-properties": "/customer-data-properties/static-1.52447",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19123",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5333",
  "onboarding-tours": "/onboarding-tours/static-1.17045",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8351",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3779",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9327",
  "user-context": "/user-context/static-1.5366",
  "bender-build-tools": "/bender-build-tools/static-1.3382",
  "dispatcher": "/dispatcher/static-1.141",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.870",
  "hubspotter-http": "/hubspotter-http/static-1.4828",
  "icons": "/icons/static-2.674",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.567",
  "module-federation": "/module-federation/static-1.30",
  "quartz-auth": "/quartz-auth/static-1.1048",
  "quartz-head": "/quartz-head/static-1.1038",
  "quartz-test": "/quartz-test/static-1.1048",
  "quartz-tracking": "/quartz-tracking/static-1.752",
  "trellis-components": "/trellis-components/static-1.2501",
  "ui-fonts": "/ui-fonts/static-1.997",
  "usage-tracker-container": "/usage-tracker-container/static-1.7598",
  "csstype": "/csstype/static-1.50",
  "hs-story-utils": "/hs-story-utils/static-1.9678",
  "data-token-picker": "/data-token-picker/static-1.16819",
  "FileManagerLib": "/FileManagerLib/static-1.40008",
  "property-translator": "/property-translator/static-1.5648",
  "atom": "/atom/static-1.5337",
  "merchandise-lib": "/merchandise-lib/static-1.273",
  "purchase-motions-components": "/purchase-motions-components/static-1.6289",
  "salesImages": "/salesImages/static-1.530",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5877",
  "react-create-root-preference": "/react-create-root-preference/static-1.63",
  "react-select-plus": "/react-select-plus/static-1.109",
  "react-virtualized": "/react-virtualized/static-2.104",
  "ui-images": "/ui-images/static-2.1230",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4663",
  "floating-ui": "/floating-ui/static-1.62",
  "react-aria": "/react-aria/static-1.70",
  "trellis-assets": "/trellis-assets/static-1.2482",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3193",
  "foundations-theming-base": "/foundations-theming-base/static-1.3695",
  "stylex": "/stylex/static-1.38",
  "interframe": "/interframe/static-3.5008",
  "js-cookie": "/js-cookie/static-1.18",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.6022",
  "web-vitals": "/web-vitals/static-1.11",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.325",
  "chirp-fetch": "/chirp-fetch/static-1.2143",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4728",
  "react-flip-move": "/react-flip-move/static-1.75",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4909",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13124",
  "content-media-compositions": "/content-media-compositions/static-2.17131",
  "idb-keyval": "/idb-keyval/static-1.48",
  "immer": "/immer/static-1.94",
  "immerable": "/immerable/static-1.4403",
  "magpie-lib": "/magpie-lib/static-1.5722",
  "magpie-types": "/magpie-types/static-1.5182",
  "media-bridge-lib": "/media-bridge-lib/static-1.19343",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4023",
  "superstore": "/superstore/static-1.5008",
  "feedback-loader": "/feedback-loader/static-1.29740",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9601",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8955",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29223",
  "ContentUtils": "/ContentUtils/static-1.69063",
  "fix-webm-duration": "/fix-webm-duration/static-1.27",
  "notification-sounds": "/notification-sounds/static-1.4676",
  "sassPrefix": "/sassPrefix/static-1.161",
  "react-dnd-compat": "/react-dnd-compat/static-1.4867",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1580",
  "copilot-toolkit": "/copilot-toolkit/static-1.11755",
  "avatar-components": "/avatar-components/static-1.2749",
  "navigation-messaging": "/navigation-messaging/static-1.8048",
  "redux-thunk": "/redux-thunk/static-2.77",
  "reference-resolvers": "/reference-resolvers/static-1.8433",
  "commerce-products-lib": "/commerce-products-lib/static-1.10416",
  "crm-message-bus": "/crm-message-bus/static-1.43649",
  "growth-data-modal": "/growth-data-modal/static-1.5824",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5131",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5259",
  "batch-promise": "/batch-promise/static-1.1794",
  "calling-global-api": "/calling-global-api/static-1.65387",
  "calling-internal-common": "/calling-internal-common/static-1.31568",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66769",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59063",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3980",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4482",
  "crm-links": "/crm-links/static-1.6576",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4314",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13281",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9861",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8350",
  "external-options-client-types": "/external-options-client-types/static-1.4305",
  "formula-editor": "/formula-editor/static-1.14683",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7144",
  "google-libphonenumber": "/google-libphonenumber/static-1.42",
  "hs-resources": "/hs-resources/static-1.443",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4390",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.888",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3874",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49546",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4148",
  "property-value-citations": "/property-value-citations/static-1.3061",
  "pulse": "/pulse/static-1.878",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.35",
  "smart-property-lib": "/smart-property-lib/static-1.8176",
  "tiered-pricing": "/tiered-pricing/static-1.1873",
  "trial-components-library": "/trial-components-library/static-1.14029",
  "topics-actions-lib": "/topics-actions-lib/static-1.415",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11238",
  "zustand": "/zustand/static-1.79",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3313",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2603",
  "navigation-components": "/navigation-components/static-1.18721",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1111",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7896",
  "ui-universal-auth": "/ui-universal-auth/static-1.9300",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18241",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10532",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5294",
  "base-ui": "/base-ui/static-1.19",
  "react-day-picker": "/react-day-picker/static-1.7",
  "trellis-theming": "/trellis-theming/static-1.1214",
  "tanstack-virtual": "/tanstack-virtual/static-1.36",
  "audio-components": "/audio-components/static-1.6279",
  "FileManagerCore": "/FileManagerCore/static-1.39867",
  "FileManagerImages": "/FileManagerImages/static-1.37519",
  "video-components": "/video-components/static-1.14073",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1419",
  "purchase-motions-api": "/purchase-motions-api/static-1.6292",
  "signup-constants": "/signup-constants/static-1.19512",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8310",
  "usage-tracker-public": "/usage-tracker-public/static-1.7419",
  "reactive-lib": "/reactive-lib/static-1.973",
  "simple-logging-lib": "/simple-logging-lib/static-1.3302",
  "chatspot-core": "/chatspot-core/static-1.22661",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6835",
  "cms-field-types": "/cms-field-types/static-1.5067",
  "content-icons-ui": "/content-icons-ui/static-1.2316",
  "integrations-lib": "/integrations-lib/static-1.16936",
  "underscore": "/underscore/static-1.8",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.558",
  "breeze-engine-core": "/breeze-engine-core/static-1.858",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.83",
  "markdown-it": "/markdown-it/static-1.6",
  "commerce-permissions": "/commerce-permissions/static-1.1028",
  "customer-data-tracking": "/customer-data-tracking/static-1.7133",
  "products-iframe-lib": "/products-iframe-lib/static-1.8505",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10916",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1563",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2420",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.590",
  "calling-error-reporting": "/calling-error-reporting/static-1.31575",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11293",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6791",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1921",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7500",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6696",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7049",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10617",
  "redux-toolkit": "/redux-toolkit/static-1.75",
  "sales-views-client-types": "/sales-views-client-types/static-1.4509",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9998",
  "bark-lib": "/bark-lib/static-1.16757",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.99",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6141",
  "react-codemirror": "/react-codemirror/static-1.10891",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.263",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4186",
  "persist-promise": "/persist-promise/static-1.3951",
  "event-emitter": "/event-emitter/static-1.1206",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.381",
  "fast-json-patch": "/fast-json-patch/static-1.67",
  "data-agent-kit": "/data-agent-kit/static-1.580",
  "fsm": "/fsm/static-1.3991",
  "policy-lib": "/policy-lib/static-1.7047",
  "react-tinymce": "/react-tinymce/static-1.55885",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10680",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.55011",
  "tinymce-plugins": "/tinymce-plugins/static-1.58125",
  "tinymce-themes": "/tinymce-themes/static-1.56981",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15381",
  "hubs-service-types": "/hubs-service-types/static-1.1510",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2631",
  "user-context-client": "/user-context-client/static-1.4760",
  "nest": "/nest/static-1.487",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1096",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.201",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.58",
  "urlinator": "/urlinator/static-1.4784",
  "video-embed": "/video-embed/static-1.36563",
  "social-insights-client-types": "/social-insights-client-types/static-1.22685",
  "flux-actions": "/flux-actions/static-1.360",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14351",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5859",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8029",
  "redux-observable": "/redux-observable/static-1.72",
  "ReduxMessenger": "/ReduxMessenger/static-2.10618",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.814",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15466",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7861",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36698",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3759",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16275",
  "browser-eslint": "/browser-eslint/static-2.57",
  "highcharts": "/highcharts/static-8.108",
  "trellis-story-utils": "/trellis-story-utils/static-1.4763",
  "storybook-react": "/storybook-react/static-1.37",
  "hub-http-contrib": "/hub-http-contrib/static-1.3291",
  "tinymce-data": "/tinymce-data/static-1.41096",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5466",
  "layout-dnd-components": "/layout-dnd-components/static-1.12898",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11873",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16233",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9227",
  "academy-common-lib": "/academy-common-lib/static-1.14841",
  "outpost": "/outpost/static-1.4412",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3260",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.362",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1076",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.939",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.31",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.383",
  "slack-ui-library": "/slack-ui-library/static-1.10650",
  "ContentData": "/ContentData/static-1.69138",
  "layout-data-lib": "/layout-data-lib/static-1.10198",
  "academy-service-client": "/academy-service-client/static-1.3941",
  "croppie": "/croppie/static-2.10",
  "final-form": "/final-form/static-1.75",
  "SafeStorage": "/SafeStorage/static-1.4657",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7565",
  "wootric-nps": "/wootric-nps/static-1.7165",
  "advanced-menus-core": "/advanced-menus-core/static-1.15516",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12396",
  "ExportDialog": "/ExportDialog/static-6.10631",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34745",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19145",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20613",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15515",
  "simple-menus-lib": "/simple-menus-lib/static-1.17032",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10753",
  "immutable-less": "/immutable-less/static-1.4903",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18020",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8278",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4173",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8263",
  "nav-meta": "/nav-meta/static-1.30358",
  "react-window": "/react-window/static-1.13",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.889",
  "apps-service-types": "/apps-service-types/static-1.3995",
  "oauth-service-types": "/oauth-service-types/static-1.4507",
  "simple-data-table": "/simple-data-table/static-1.3443"
}
};
